import $ from 'jquery';
import utils from '../utils/index';

const _html = document.querySelector('html');
const _body = document.body;
let ticking = false;

function onScroll() {
  const { scrollY, innerHeight } = window;

  utils.setCssVar(_html, {
    'scroll-y': `${scrollY}px`,
    'scroll-y-progress': scrollY / (_body.scrollHeight - innerHeight),
    'first-screen-removal-progress': scrollY / window.innerHeight,
  });
  ticking = false;
}

document.onscroll = () => {
  if (!ticking) {
    requestAnimationFrame(onScroll);
    ticking = true;
  }
};

$(document).trigger('scroll');
